
import { Link } from 'react-router-dom';
import PageHero from '../../../components/base/PageHero';

export default function CorporateHeroSection() {
  return (
    <PageHero
      breadcrumb="Corporate Training"
      label="For Organisations"
      title="Corporate Training That Drives Real Performance"
      description="Customised training programmes designed around your business strategy — measurable outcomes, SETA-fundable, and delivered by industry-experienced facilitators."
      bgImage="/corporate-training-hero.png"
    >
      <Link to="/contact"><button className="btn btn-white">Get a Proposal <i className="ri-arrow-right-line ml-2" /></button></Link>
      <Link to="/seta-compliance"><button className="btn btn-ghost">SETA Compliance</button></Link>
    </PageHero>
  );
}
